'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bignumber = require('bignumber.js');

var _bignumber2 = _interopRequireDefault(_bignumber);

var _assert = require('assert');

var _assert2 = _interopRequireDefault(_assert);

var _lodash = require('lodash.indexby');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = converter;

module.exports = converter;

function mult(a, b) {
  return new _bignumber2.default(a).times(b).toNumber();
}

function div(a, b) {
  return new _bignumber2.default(a).dividedBy(b).toNumber();
}

function convertFromUnitQty(_ref) {
  var count = _ref.count,
      unitQty = _ref.unitQty;

  return div(count, unitQty);
}

function convertToUnitQty(_ref2) {
  var count = _ref2.count,
      unitQty = _ref2.unitQty;

  return mult(count, unitQty);
}

function converter(options) {
  options.types.forEach(function (t) {
    (0, _assert2.default)(t.id, 'Type provided without an id');
    (0, _assert2.default)(t.qty !== undefined, 'Type ' + t.id + ' does not have an associated qty');
    (0, _assert2.default)(typeof t.qty === 'number', 'Type ' + t.id + ' has an associated qty that is not numeric (' + JSON.stringify(t.qty) + ')');
    (0, _assert2.default)(t.qty > 0, 'Type ' + t.id + ' has a qty that is not a positive number (' + t.qty + ')');
  });

  var typesById = (0, _lodash2.default)(options.types, 'id');
  if (!typesById[undefined]) {
    typesById[undefined] = {
      id: undefined,
      qty: 1,
      name: options.baseUnitName
    };
  }

  function getType(typeId) {
    if (typeId === null) {
      typeId = undefined;
    }
    var type = typesById[typeId];
    if (type === undefined) {
      throw new Error(typeId + ' is not a valid type');
    }
    return type;
  }

  return {
    convertTo: function convertTo(count, typeId) {
      return div(count, getType(typeId).qty);
    },

    strConvertTo: function strConvertTo(count, typeId) {
      var type = getType(typeId);
      var value = div(count, type.qty);
      return value + ' x ' + type.name;
    },

    convertFrom: function convertFrom(count, typeId) {
      return mult(count, getType(typeId).qty);
    },

    strConvertFrom: function strConvertFrom(count, typeId) {
      var value = mult(count, getType(typeId).qty);
      return value + ' x ' + options.baseUnitName;
    }
  };
}

converter.convertFromUnitQty = convertFromUnitQty;
converter.convertToUnitQty = convertToUnitQty;